/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION = 'SET_OVERLAY_HIGHLIGHT_VERTICAL_POSITION';
export const SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION =
    'SET_OVERLAY_HIGHLIGHT_HORIZONTAL_POSITION';
export const SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT = 'SET_OVERLAY_HIGHLIGHT_HORIZONTAL_LIMIT';
export const SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT = 'SET_OVERLAY_HIGHLIGHT_VERTICAL_LIMIT';
export const OVERLAY_SET_GHOST_MODE = 'OVERLAY_SET_GHOST_MODE';
